import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../Common/svg/deleteicon";
import EditIcon from "../../Common/svg/editIcon";
import InactiveIcon from "../../Common/svg/inactiveicon";
import ShowIcon from "../../Common/svg/showIcon";
import ActiveIcon from "../../Common/svg/activeicon";
import Can from "../../../utils/can";

import { toast } from "react-toastify";
import { useMutation, useQueryClient } from "react-query";
import { Tooltip } from "react-tooltip";

const TableActions = ({
  show,
  edit,
  activeStatus,
  is_active,
  isLoading,
  id,
  mutationKey,
  refetch,
  deleteFn,
  queryKey,
  viewPermission,
  editPermission,
  deletePermission,
  togglePermission,
  toggleMutationKey,
  toggleFn
}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const deleteMutation = useMutation({
    mutationKey,
    mutationFn: (id) => deleteFn(id),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      queryKey ? queryClient.invalidateQueries(queryKey) : refetch?.();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message);
    },
  });

  const toggleMutation = useMutation({
  mutationKey: toggleMutationKey || ["toggle", id],

  mutationFn: () => {
    const nextStatus = is_active ? 0 : 1;
    return toggleFn(id, nextStatus);
  },

  onSuccess: (data) => {
    toast.success(data?.message || "تم تغيير الحالة");

    queryKey
      ? queryClient.invalidateQueries(queryKey)
      : refetch?.();
  },

  onError: (error) => {
    toast.error(error?.response?.data?.message);
  },
});

  return (
    <div className="d-flex align-items-center justifiy-content-center gap-2 custom-btn ">
           <Tooltip id="show" content="عرض  التفاصيل"  className="custom-tooltip show" />
      {show ? (
        <Can permission={viewPermission}>
          <button
          data-tooltip-id="show"
            className=" bg-none"
            onClick={() => {
              if (typeof show === "string") {
                navigate(show);
              } else if (typeof show === "function") {
                show();
              }
            }}
          >
            <ShowIcon />
          </button>
        </Can>
      ) : null}
     <Tooltip id="edit" content="تعديل"   className="custom-tooltip edit" />
      {edit ? (
        <Can permission={editPermission}>
          <button
          data-tooltip-id="edit"
          id="edit"
  
            className=" bg-none"
            onClick={() => {
              if (typeof edit === "string") {
                navigate(edit);
              } else if (typeof edit === "function") {
                edit();
              }
            }}
          >
       
            <EditIcon />
          </button>
        </Can>
      ) : null}
    <Tooltip id="delete" content="حذف"   className="custom-tooltip delete" />
      {deleteFn ? (
        <Can permission={deletePermission}>
          <button
           
            data-tooltip-id="delete"
            className=" bg-none"
            onClick={() => deleteMutation.mutate(id)}
            disabled={deleteMutation.isLoading}
          >
            <DeleteIcon />
          </button>
        </Can>
      ) : null}
  <Tooltip id="active" content="حالة النشاط"  className="custom-tooltip show" />
      {toggleFn ? (
        <Can permission={togglePermission}>
          <button
            data-tooltip-id="active"
            title="إيقاف"
            className={`bg-none ${isLoading ? "disabled" : ""}`}
            onClick={() => toggleMutation.mutate()}
            disabled={toggleMutation.isLoading}

          >
            {is_active ? <InactiveIcon /> : <ActiveIcon />}
          </button>
        </Can>
      ) : null}
    </div>
  );
};
export default TableActions;
